import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

// --- START INLINE SVG ICONS ---
// (SVG icon components remain the same)
const IconPlay = (props) => (
  <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" {...props}><path d="M8 5v14l11-7z"></path></svg>
);
const IconCheck = (props) => (
  <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" {...props}><polyline points="20 6 9 17 4 12"></polyline></svg>
);
const IconStar = (props) => (
  <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" {...props}><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"></path></svg>
);
const IconUsers = (props) => (
  <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
);
const IconChevronDown = (props) => (
  <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" {...props}><polyline points="6 9 12 15 18 9"></polyline></svg>
);
const IconArrowRight = (props) => (
  <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" {...props}><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
);
const IconZap = (props) => (
  <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" {...props}><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg>
);
const IconBookOpen = (props) => (
  <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path></svg>
);
const IconAward = (props) => (
  <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" {...props}><circle cx="12" cy="8" r="7"></circle><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline></svg>
);
const IconX = (props) => (
  <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" {...props}><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
);
const IconBarChart2 = (props) => (
  <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" {...props}><line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line><line x1="6" y1="20" x2="6" y2="14"></line></svg>
);
const IconLock = (props) => (
  <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" {...props}><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
);
const IconBriefcase = (props) => (
  <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" {...props}><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg>
);
const IconPhoneCall = (props) => (
  <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
);
const IconMessageCircle = (props) => (
  <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>
);
const IconBot = (props) => (
  <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M12 8V4H8" /><rect x="4" y="12" width="16" height="8" rx="2" /><path d="M2 12h2" /><path d="M20 12h2" /><path d="M12 12v-2" /></svg>
);
const IconDownload = (props) => (
  <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
);
const IconShoppingCart = (props) => (
  <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" {...props}><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>
);
const IconMail = (props) => (
  <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
);
const IconPhone = (props) => (
  <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
);
// --- END INLINE SVG ICONS ---

const RegistrationModal = ({ isOpen, onClose, formData, setFormData, onSubmit }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  if (!isOpen) return null;

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
          className="fixed inset-0 z-[99999] bg-black/80 backdrop-blur-md flex items-center justify-center p-4"
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0, y: 50 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.9, opacity: 0, y: 50 }}
            transition={{ type: 'spring', stiffness: 300, damping: 30 }}
            onClick={(e) => e.stopPropagation()}
            className="relative bg-gradient-to-br from-gray-900 via-yellow-900 to-amber-900 border-2 border-yellow-400/50 rounded-3xl p-6 sm:p-8 max-w-md w-full shadow-2xl card-premium"
          >
            <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors">
              <IconX className="w-6 h-6" />
            </button>
            <div className="text-center mb-6">
              <h2 className="text-2xl sm:text-3xl font-black text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-amber-500 mb-2 heading-secondary-premium">
                Secure Your eBook & Bonuses
              </h2>
              <p className="text-gray-400 body-premium">Enter your details to proceed to payment for just ₹97.</p>
            </div>
            <form onSubmit={onSubmit} className="space-y-4">
              <div>
                <label htmlFor="full_name" className="block text-sm font-bold text-yellow-300 mb-2">Full Name</label>
                <input
                  type="text"
                  name="full_name"
                  id="full_name"
                  value={formData.full_name}
                  onChange={handleChange}
                  required
                  className="w-full rounded-lg px-4 py-3 text-white placeholder-gray-500 focus:outline-none transition input-premium bg-gray-800/50 border-2 border-yellow-400/30 focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 text-base"
                  placeholder="Enter your full name"
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-bold text-yellow-300 mb-2">Email Address</label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full rounded-lg px-4 py-3 text-white placeholder-gray-500 focus:outline-none transition input-premium bg-gray-800/50 border-2 border-yellow-400/30 focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 text-base"
                  placeholder="Enter your email"
                />
              </div>
              <div>
                <label htmlFor="phoneNumber" className="block text-sm font-bold text-yellow-300 mb-2">Phone Number</label>
                <div className="flex items-center">
                  <select
                    name="countryCode"
                    id="countryCode"
                    value={formData.countryCode}
                    onChange={handleChange}
                    className="bg-gray-800/50 border-2 border-r-0 border-yellow-400/30 rounded-l-lg px-3 py-3 text-white focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 transition appearance-none input-premium text-base"
                    style={{ backgroundImage: 'none' }}
                  >
                    <option>+91</option>
                    <option>+1</option>
                    <option>+44</option>
                    <option>+61</option>
                    <option>+971</option>
                  </select>
                  <input
                    type="tel"
                    name="phoneNumber"
                    id="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={handleChange}
                    required
                    className="w-full rounded-r-lg px-4 py-3 text-white placeholder-gray-500 focus:outline-none transition input-premium bg-gray-800/50 border-2 border-l-0 border-yellow-400/30 focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 text-base"
                    placeholder="98765 43210"
                  />
                </div>
              </div>
              <motion.button
                type="submit"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                className="w-full text-black font-black py-4 px-6 rounded-xl text-lg shadow-2xl relative overflow-hidden transition-all duration-300 bg-gradient-to-r from-yellow-400 via-yellow-300 to-yellow-500 hover:from-yellow-500 hover:via-yellow-400 hover:to-yellow-300"
              >
                <span className="relative z-10 flex items-center justify-center gap-2">
                  <IconLock className="w-5 h-5" />
                  Proceed to Payment - ₹97
                  <IconArrowRight className="w-5 h-5" />
                </span>
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -skew-x-12 animate-shimmer"></div>
              </motion.button>
            </form>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

function App() {
  const [bonusTimeLeft, setBonusTimeLeft] = useState({ minutes: 14, seconds: 59 });
  const [openFaq, setOpenFaq] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    full_name: '',
    email: '',
    countryCode: '+91',
    phoneNumber: ''
  });

  useEffect(() => {
    const timer = setInterval(() => {
      setBonusTimeLeft(prev => {
        if (prev.seconds > 0) {
          return { ...prev, seconds: prev.seconds - 1 };
        } else if (prev.minutes > 0) {
          return { minutes: prev.minutes - 1, seconds: 59 };
        } else {
          return { minutes: 14, seconds: 59 };
        }
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const testimonials = [
    { name: "Rajesh Kumar", role: "Business Owner", quote: "Closed ₹2.5L in Diwali week using just 5 of these strategies. This eBook is pure gold!", rating: 5 },
    { name: "Priya Sharma", role: "Consultant", quote: "My income doubled! I went from 3 to over 15 qualified leads per week. The automation templates are a game-changer.", rating: 5 },
    { name: "Amit Patel", role: "Agency Owner", quote: "We scaled from 10 to 50 clients because of the automation templates. Best ₹97 I've ever spent on my business.", rating: 5 },
    { name: "Sneha Gupta", role: "Online Coach", quote: "Made ₹8L during my Diwali campaign using the strategies from this eBook. It's a must-have for any professional.", rating: 5 },
    { name: "Vikram Singh", role: "Local Store Owner", quote: "My foot traffic increased by over 200%! The digital strategies are simple to implement and incredibly effective.", rating: 5 }
  ];

  const bonuses = [
    { title: "Diwali Workshop", value: "₹4,999", description: "A step-by-step video guide to implement the top 20 sales boosting strategies from the eBook.", icon: IconPlay, premium: true },
    { title: "WhatsApp & Email Automation Templates", value: "₹3,999", description: "Ready-to-use, plug-and-play conversion flows to nurture leads and close sales automatically.", icon: IconMessageCircle, premium: true },
    { title: "Free Software Access", value: "₹5,999", description: "Get complimentary access to our powerful CRM and marketing automation tools.", icon: IconBot, premium: true },
    { title: "Bulk WhatsApp Tutorial", value: "₹6,999", description: "Learn how to safely send up to 5 lakh messages to promote your offers without getting blocked.", icon: IconPhoneCall, premium: false },
    { title: "Lead Generation Strategy Playbook", value: "₹3,499", description: "Proven strategies to fill your sales funnel with high-quality leads every single day.", icon: IconUsers, premium: false }
  ];

  const faqs = [
    { question: "Is this eBook beginner-friendly?", answer: "Absolutely! The 24 strategies are explained in a simple, step-by-step format that anyone can understand and implement, regardless of their technical skill level." },
    { question: "Will it work for my business?", answer: "Yes! These strategies are universally applicable for business owners, professionals, coaches, trainers, consultants, freelancers, local stores, and agency owners. If you need to generate leads and increase sales, this eBook is for you." },
    { question: "How do I access my bonuses?", answer: "Once you complete your purchase for ₹97, you'll receive an email with an instant download link for the eBook and access links for all the bonuses, including the workshop and software." },
    { question: "Can I automate WhatsApp safely?", answer: "Yes. Our Bulk WhatsApp Tutorial (Bonus #4) provides a detailed guide on how to send promotional messages safely and effectively, following best practices to avoid getting your number blocked." },
    { question: "What if I’m not tech-savvy?", answer: "No problem! The included workshop and automation templates are designed to be user-friendly. We focus on simple, powerful tools that don't require any coding knowledge." },
    { question: "Is there a refund or support policy?", answer: "Due to the digital nature of the product and the instant delivery of immense value, we do not offer refunds. However, we have a 7-Day Action Guarantee and provide dedicated email and phone support to help you succeed." }
  ];

  // Tracking and form submission logic remains the same
  useEffect(() => {
    if (typeof window.fbq !== 'undefined') {
      window.fbq('track', 'ViewContent', {
        content_name: 'Diwali Sales eBook Landing Page',
        content_category: 'eBook',
        content_type: 'product',
        value: 97.00,
        currency: 'INR'
      });
    }
    if (typeof window !== 'undefined' && window.yinguru) {
      window.yinguru.track('PageView', {
        page_title: 'Diwali Sales eBook Landing Page',
        page_url: window.location.href,
        event_category: 'eBook',
        event_action: 'Page View'
      });
    }
  }, []);

  useEffect(() => {
    if (document.querySelector('script[data-tracking-id="tk_3c2878362376441bbaf8f6bb87d0e34d"]')) {
      return;
    }
    const script = document.createElement('script');
    script.src = "https://dmc.yinguru.com/js/external-tracking.js";
    script.setAttribute('data-tracking-id', 'tk_3c2878362376441bbaf8f6bb87d0e34d');
    script.async = true;
    script.onload = () => {
      if (window.yinguru) {
        window.yinguru.track('PageView', {
          page_title: 'Diwali Sales eBook Landing Page',
          page_url: window.location.href,
          event_category: 'eBook',
          event_action: 'Page Load Complete'
        });
      }
    };
    document.head.appendChild(script);
    return () => {
      const existingScript = document.querySelector('script[data-tracking-id="tk_3c2878362376441bbaf8f6bb87d0e34d"]');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  const openRegistrationModal = () => {
    setIsModalOpen(true);
    if (typeof window.fbq !== 'undefined') {
      window.fbq('track', 'Lead', {
        content_name: 'Registration Modal Opened',
        content_category: 'eBook',
        event_action: 'Modal Open'
      });
    }
    if (window.yinguru) {
      window.yinguru.track('ModalOpen', {
        modal_name: 'Registration Modal',
        event_category: 'User Interaction',
        event_action: 'Modal Open'
      });
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (typeof window.fbq !== 'undefined') {
      window.fbq('track', 'Lead', {
        content_name: 'Diwali Sales eBook Registration',
        content_category: 'eBook',
        value: 97.00,
        currency: 'INR'
      });
      window.fbq('track', 'InitiateCheckout', {
        content_name: 'Diwali Sales eBook',
        content_category: 'Education',
        value: 97.00,
        currency: 'INR',
        num_items: 1
      });
    }

    if (window.yinguru) {
      window.yinguru.track('FormSubmission', {
        form_name: 'Registration Form',
        event_category: 'Lead Generation',
        event_action: 'Form Submit',
        value: 97.00,
        currency: 'INR',
        user_data: {
          name: formData.full_name,
          email: formData.email,
          phone: `${formData.countryCode}${formData.phoneNumber}`
        }
      });
    }

    const fullPhoneNumber = `${formData.countryCode}${formData.phoneNumber}`;
    const webhookUrl = "https://connect.pabbly.com/workflow/sendwebhookdata/IjU3NjYwNTY1MDYzZjA0MzU1MjY4NTUzMjUxMzIi_pc";
    try {
      fetch(webhookUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          full_name: formData.full_name,
          email: formData.email,
          phoneNumber: fullPhoneNumber,
        }),
      });
    } catch (error) {
      console.error('Webhook submission error:', error);
    }
    
    if (window.yinguru) {
      window.yinguru.track('WebhookSubmission', {
        event_category: 'Data Processing',
        event_action: 'Webhook Success',
        webhook_url: webhookUrl
      });
    }
    
    const baseUrl = "https://paymentz.aifunnels.app/product/21362/page/19544/addon-page";
    const params = new URLSearchParams({
      first_name: formData.full_name,
      email: formData.email,
      phone_no: fullPhoneNumber,
      staffId: '65130',
      ac: '1'
    });
    const paymentUrl = `${baseUrl}?${params.toString()}`;
    
    if (window.yinguru) {
      window.yinguru.track('PaymentRedirect', {
        event_category: 'Conversion',
        event_action: 'Payment Page Redirect',
        payment_url: paymentUrl,
        value: 97.00,
        currency: 'INR'
      });
    }
    
    window.open(paymentUrl, '_blank');
    setIsModalOpen(false);
  };

  const FloatingElement = ({ children, delay = 0 }) => (
    <motion.div
      animate={{ y: [-10, 10, -10], rotate: [-1, 1, -1] }}
      transition={{ duration: 6, repeat: Infinity, delay, ease: "easeInOut" }}
    >
      {children}
    </motion.div>
  );

  const StickyButton = () => (
    <div className="fixed bottom-0 left-0 right-0 z-[9999] p-3 bg-gradient-to-t from-black via-black/95 to-transparent backdrop-blur-sm border-t border-yellow-400/20 no-print">
      <motion.button
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        onClick={openRegistrationModal}
        className="w-full text-black font-black py-3 sm:py-4 px-6 rounded-2xl text-base shadow-2xl relative overflow-hidden transition-all duration-300 bg-gradient-to-r from-yellow-400 via-yellow-300 to-yellow-500 hover:from-yellow-500 hover:via-yellow-400 hover:to-yellow-300"
      >
        <span className="relative z-10 flex items-center justify-center gap-2">
            <IconDownload className="w-5 h-5 flex-shrink-0" />
            <span className="font-black text-center leading-tight">
              Get Instant Access for ₹97
              <br />
              <span className="text-sm font-bold">Bonuses Included!</span>
            </span>
            <IconArrowRight className="w-5 h-5 flex-shrink-0" />
        </span>
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -skew-x-12 animate-shimmer"></div>
      </motion.button>
    </div>
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-amber-900 to-yellow-900 relative overflow-hidden">
      <RegistrationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        formData={formData}
        setFormData={setFormData}
        onSubmit={handleFormSubmit}
      />
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-yellow-400 to-amber-600"></div>
        <div className="absolute top-10 left-10 w-48 h-48 sm:w-96 sm:h-96 bg-yellow-400 rounded-full blur-3xl opacity-10 animate-pulse"></div>
        <div className="absolute bottom-10 right-10 w-40 h-40 sm:w-80 sm:h-80 bg-amber-500 rounded-full blur-3xl opacity-10 animate-pulse delay-1000"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[300px] h-[300px] sm:w-[600px] sm:h-[600px] bg-gradient-radial from-yellow-300 to-transparent opacity-5 animate-spin-slow"></div>
      </div>

      <StickyButton />

      <div className="pb-24">
        <section className="relative min-h-screen flex flex-col justify-center overflow-hidden px-4 pt-20 sm:pt-0">
          <header className="absolute top-0 left-0 right-0 z-20 p-4 no-print">
            {/* --- FIX STARTS HERE --- */}
            <div className="max-w-7xl mx-auto flex justify-center md:justify-between items-center">
            {/* --- FIX ENDS HERE --- */}
              <div className="text-2xl font-black text-white">🪔 YinGuru</div>
              <nav className="hidden md:flex items-center gap-6 text-sm font-bold text-gray-300">
                <a href="#learn" className="hover:text-yellow-400 transition-colors">What You’ll Learn</a>
                <a href="#bonuses" className="hover:text-yellow-400 transition-colors">Bonuses</a>
                <a href="#testimonials" className="hover:text-yellow-400 transition-colors">Testimonials</a>
                <a href="#faq" className="hover:text-yellow-400 transition-colors">FAQs</a>
                <button
                  onClick={openRegistrationModal}
                  className="text-black font-bold px-4 py-2 rounded-lg relative overflow-hidden transition-all duration-300 bg-gradient-to-r from-yellow-400 via-yellow-300 to-yellow-500 hover:from-yellow-500 hover:via-yellow-400 hover:to-yellow-300"
                >
                  <span className="relative z-10">Buy Now</span>
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent -skew-x-12 animate-shimmer"></div>
                </button>
              </nav>
            </div>
          </header>

          <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-amber-900 to-yellow-900"></div>
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-yellow-500/10"></div>
          
          <FloatingElement delay={0}><div className="absolute top-16 left-6 w-3 h-3 bg-yellow-400 rounded-full blur-sm opacity-60"></div></FloatingElement>
          <FloatingElement delay={2}><div className="absolute top-32 right-8 w-4 h-4 bg-amber-500 rounded-full blur-sm opacity-40"></div></FloatingElement>
          <FloatingElement delay={4}><div className="absolute bottom-32 left-8 w-2 h-2 bg-yellow-300 rounded-full blur-sm opacity-50"></div></FloatingElement>

          <div className="relative z-10 max-w-4xl mx-auto text-center">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="space-y-6"
            >
              <motion.h2
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4 }}
                className="text-4xl sm:text-5xl md:text-6xl font-black text-white leading-tight heading-premium text-shadow-premium pt-24 sm:pt-28 md:pt-32 lg:pt-36"
              >
                Struggling to Get Sales?
                <br />
                Learn 24 Ways to Fix It and  
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-amber-500 text-shadow-glow">
                    Double Your Income This Diwali!
                </span> 🪔
              </motion.h2>

              <motion.p 
                initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.6 }}
                className="text-base sm:text-lg text-gray-300 max-w-3xl mx-auto body-premium"
              >
                Grab the ultimate ₹97 Diwali eBook packed with 24 practical growth hacks, free automation tools, and a bonus workshop to help you double your leads, automate follow-ups, and boost sales before the festive season ends.
              </motion.p>
              
              <motion.div 
                className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 text-left max-w-xl mx-auto"
                initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.8 }}
              >
                <div className="flex items-center gap-2"><IconCheck className="w-5 h-5 text-green-400 flex-shrink-0"/><span className="text-sm text-gray-200">24+ proven tactics to 2X income</span></div>
                <div className="flex items-center gap-2"><IconCheck className="w-5 h-5 text-green-400 flex-shrink-0"/><span className="text-sm text-gray-200">Diwali-special workshop</span></div>
                <div className="flex items-center gap-2"><IconCheck className="w-5 h-5 text-green-400 flex-shrink-0"/><span className="text-sm text-gray-200">WhatsApp & Email automation</span></div>
                <div className="flex items-center gap-2"><IconCheck className="w-5 h-5 text-green-400 flex-shrink-0"/><span className="text-sm text-gray-200">Works for all business owners</span></div>
              </motion.div>

              <motion.div 
                initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} transition={{ delay: 1.0 }}
                className="glass-premium rounded-2xl p-4 max-w-md mx-auto"
              >
                <div className="text-white text-center">
                  <span className="text-gray-300 font-bold">Regular Price: <span className="line-through">₹997</span> → 90% OFF</span>
                  <div className="text-2xl font-black text-yellow-400 my-1 text-shadow-glow">🎉 Diwali Offer: Only ₹97 Today</div>
                  <div className="text-xs text-amber-400 font-medium bg-amber-400/10 rounded-full px-3 py-1 inline-block">⏰ Limited Offer – First 15 Minutes Only!</div>
                </div>
              </motion.div>

               <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 1.2 }}
                className="space-y-4 px-2"
              >
                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  onClick={openRegistrationModal}
                  className="text-black font-black py-5 px-8 rounded-2xl text-lg shadow-2xl border-2 border-yellow-300 w-full relative overflow-hidden transition-all duration-300 bg-gradient-to-r from-yellow-400 via-yellow-300 to-yellow-500 hover:from-yellow-500 hover:via-yellow-400 hover:to-yellow-300"
                >
                  <span className="relative z-10 flex items-center justify-center gap-2">
                    <IconDownload className="w-5 h-5" />
                    👉 Get Instant Access for ₹97
                  </span>
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -skew-x-12 animate-shimmer"></div>
                </motion.button>

                <div className="text-yellow-400 text-sm font-medium text-center">
                  Secure Payment | Instant Download | Bonuses Included
                </div>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 1.4 }}
                className="bg-gradient-to-r from-red-600/20 to-orange-600/20 backdrop-blur-lg border-2 border-red-400/50 rounded-2xl p-4 max-w-xs mx-auto shadow-2xl"
              >
                <div className="grid grid-cols-2 gap-3 text-center">
                  <div className="bg-gradient-to-r from-red-500 to-orange-500 rounded-xl p-3 border border-red-400">
                    <div className="text-2xl font-black text-white">{bonusTimeLeft.minutes.toString().padStart(2, '0')}</div>
                    <div className="text-xs text-red-200 uppercase font-bold">Minutes</div>
                  </div>
                  <div className="bg-gradient-to-r from-red-500 to-orange-500 rounded-xl p-3 border border-red-400">
                    <div className="text-2xl font-black text-white">{bonusTimeLeft.seconds.toString().padStart(2, '0')}</div>
                    <div className="text-xs text-red-200 uppercase font-bold">Seconds</div>
                  </div>
                </div>
              </motion.div>
            </motion.div>
          </div>
        </section>

        {/* --- All other sections remain the same --- */}
        
        <section className="py-12 sm:py-20 bg-gradient-to-b from-black to-amber-900 relative">
          <div className="absolute inset-0 bg-gradient-to-r from-yellow-500/5 to-amber-500/5"></div>
          <div className="relative z-10 max-w-4xl mx-auto px-4 text-center">
            <motion.h2
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              className="text-3xl sm:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-red-400 to-orange-500 mb-6"
            >
              🎁💰 Why You're Still Struggling to Grow Sales (and Losing Money Daily) 😩
            </motion.h2>
            <div className="grid sm:grid-cols-3 gap-6 max-w-4xl mx-auto mb-8">
              {[
                { point: "No Consistent Leads", detail: "Relying on luck, not systems", icon: IconX },
                { point: "Manual Follow-Ups", detail: "Missed prospects = lost income", icon: IconX },
                { point: "No Clear Offer", detail: "Confused prospects never buy", icon: IconX },
              ].map((item, index) => (
                <motion.div 
                  key={index}
                  initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: index * 0.1 }}
                  className="flex items-start gap-3 p-4 bg-gradient-to-r from-red-500/10 to-orange-500/10 border border-red-400/30 rounded-xl"
                >
                  <item.icon className="text-red-400 w-6 h-6 mt-1 flex-shrink-0" />
                  <div>
                    <h3 className="text-lg font-bold text-white">{item.point}</h3>
                    <p className="text-gray-400">{item.detail}</p>
                  </div>
                </motion.div>
              ))}
            </div>
            <motion.div
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.4 }}
            >
              <p className="text-lg text-yellow-300 font-medium mb-6">This Diwali, end the struggle. These 24 proven ways will turn chaos into consistent sales. 🎯</p>
              <motion.button
                whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }} onClick={openRegistrationModal}
                className="bg-gradient-to-r from-yellow-400 via-yellow-300 to-yellow-500 hover:from-yellow-500 hover:via-yellow-400 hover:to-yellow-300 text-black font-bold py-3 px-8 rounded-lg text-lg relative overflow-hidden transition-all duration-300"
              >
                <span className="relative z-10">Show Me The Solution →</span>
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent -skew-x-12 animate-shimmer"></div>
              </motion.button>
            </motion.div>
          </div>
        </section>

        <section id="learn" className="py-12 sm:py-20 bg-gradient-to-b from-amber-900 to-black relative">
          <div className="absolute inset-0 bg-gradient-to-r from-yellow-500/5 to-amber-500/5"></div>
          <div className="relative z-10 max-w-7xl mx-auto px-4">
            <motion.div
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              className="text-center mb-12"
            >
              <h2 className="text-3xl sm:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-amber-500 mb-4">
                📘 Your Step-by-Step Playbook to Double Your Sales Fast
              </h2>
              <p className="text-lg text-gray-300 font-medium">24 comprehensive sections with proven, actionable strategies.</p>
            </motion.div>

            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
              {[
                "Lead Magnets & Offers", "WhatsApp & Email Automations", "Conversion Boosters", "Pricing & Festive Bundles",
                "Follow-Up Systems", "Customer Retention Hacks", "Upsell & Referral Strategies", "Content That Converts",
                "CRM & AI Tools", "Diwali Campaign Templates"
              ].map((item, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: index * 0.05 }}
                  className="bg-gradient-to-b from-gray-800/50 to-amber-900/50 backdrop-blur-lg border border-yellow-400/20 rounded-xl p-4 text-center"
                >
                  <div className="w-10 h-10 bg-gradient-to-r from-yellow-400 to-amber-500 rounded-full flex items-center justify-center mx-auto mb-3">
                    <span className="text-black font-black text-lg">{index + 1}</span>
                  </div>
                  <p className="text-white font-bold text-sm leading-tight">{item}</p>
                </motion.div>
              ))}
            </div>
            <motion.div 
              className="text-center mt-12"
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.5 }}
            >
              <button
                onClick={openRegistrationModal}
                className="bg-gradient-to-r from-yellow-400 via-yellow-300 to-yellow-500 hover:from-yellow-500 hover:via-yellow-400 hover:to-yellow-300 text-black font-black py-4 px-8 rounded-lg text-lg shadow-xl relative overflow-hidden transition-all duration-300"
              >
                <span className="relative z-10">Unlock All 24 Ways for ₹97 →</span>
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent -skew-x-12 animate-shimmer"></div>
              </button>
            </motion.div>
          </div>
        </section>

        <section id="bonuses" className="py-12 sm:py-20 bg-gradient-to-b from-black to-amber-900 relative overflow-hidden">
          <FloatingElement delay={0}><div className="absolute top-20 left-20 w-32 h-32 bg-yellow-400/20 rounded-full blur-2xl"></div></FloatingElement>
          <FloatingElement delay={3}><div className="absolute bottom-20 right-20 w-40 h-40 bg-amber-500/20 rounded-full blur-2xl"></div></FloatingElement>

          <div className="relative z-10 max-w-7xl mx-auto px-4">
            <motion.div
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              className="text-center mb-12"
            >
              <h2 className="text-3xl sm:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-amber-500 mb-6">
                🎁 Act Within 15 Minutes & Get These Diwali Bonuses FREE
              </h2>
              <div className="bg-gradient-to-r from-red-600/30 to-orange-600/30 backdrop-blur-lg border-2 border-red-400/50 rounded-2xl p-6 max-w-sm mx-auto shadow-2xl">
                <div className="grid grid-cols-2 gap-4 text-center">
                  <div className="bg-gradient-to-r from-red-500 to-orange-500 rounded-xl p-4 border-2 border-red-400">
                    <div className="text-3xl font-black text-white">{bonusTimeLeft.minutes.toString().padStart(2, '0')}</div>
                    <div className="text-sm text-red-200 uppercase font-bold">Minutes</div>
                  </div>
                  <div className="bg-gradient-to-r from-red-500 to-orange-500 rounded-xl p-4 border-2 border-red-400">
                    <div className="text-3xl font-black text-white">{bonusTimeLeft.seconds.toString().padStart(2, '0')}</div>
                    <div className="text-sm text-red-200 uppercase font-bold">Seconds</div>
                  </div>
                </div>
              </div>
            </motion.div>

            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {bonuses.map((bonus, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: index * 0.1 }}
                  className={`bg-gradient-to-b from-gray-800/60 to-amber-900/60 backdrop-blur-lg border-2 ${bonus.premium ? 'border-yellow-400/50' : 'border-gray-600/50'} rounded-2xl p-6 shadow-2xl`}
                >
                  <div className="text-center">
                    <div className={`w-16 h-16 ${bonus.premium ? 'bg-gradient-to-r from-yellow-400 to-amber-500' : 'bg-gradient-to-r from-gray-600 to-gray-700'} rounded-full flex items-center justify-center mx-auto mb-4`}>
                      <bonus.icon className={`w-8 h-8 ${bonus.premium ? 'text-black' : 'text-white'}`} />
                    </div>
                    <div className="bg-gradient-to-r from-green-500 to-emerald-500 text-white text-sm font-black py-1 px-3 rounded-full inline-block mb-3">FREE BONUS</div>
                    <h3 className="text-lg font-black text-white mb-3">{bonus.title}</h3>
                    <div className="text-2xl font-black text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-500 mb-3">{bonus.value}</div>
                    <p className="text-gray-400 text-sm leading-relaxed">{bonus.description}</p>
                  </div>
                </motion.div>
              ))}
            </div>

            <motion.div
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.5 }}
              className="text-center mt-12 bg-gray-900/50 border border-yellow-400/30 rounded-2xl p-6 max-w-lg mx-auto"
            >
              <div className="text-2xl font-bold text-gray-300">Total Bonus Value: <span className="text-yellow-400">₹25,495</span></div>
              <div className="text-3xl font-black text-white my-2">Your Price Today: <span className="text-green-400">₹97 Only</span></div>
              <motion.button
                onClick={openRegistrationModal}
                whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}
                className="w-full mt-4 bg-gradient-to-r from-yellow-400 via-yellow-300 to-yellow-500 hover:from-yellow-500 hover:via-yellow-400 hover:to-yellow-300 text-black font-black py-4 px-6 rounded-xl text-lg relative overflow-hidden transition-all duration-300"
              >
                <span className="relative z-10">🔥 Yes! I Want the eBook + Bonuses →</span>
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent -skew-x-12 animate-shimmer"></div>
              </motion.button>
            </motion.div>
          </div>
        </section>

        <section className="py-12 sm:py-20 bg-gradient-to-b from-amber-900 to-black relative">
          <div className="relative z-10 max-w-4xl mx-auto px-4 text-center">
            <motion.h2 
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              className="text-3xl sm:text-5xl font-black text-white mb-8"
            >
              💔 Still Thinking? <span className="text-red-500">Here's What It's Costing You…</span>
            </motion.h2>
            <div className="grid sm:grid-cols-3 gap-6 text-gray-300 mb-8">
              <p>📅 Another festive season gone without results</p>
              <p>🏃‍♂️ Competitors grabbing your customers</p>
              <p>😰 Lost leads, missed profits, sleepless nights</p>
            </div>
            <motion.div
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.3 }}
            >
              <p className="text-xl font-bold text-yellow-400 mb-6">Don’t let this Diwali be another regret — take action now. 🎯</p>
              <button 
                onClick={openRegistrationModal}
                className="bg-gradient-to-r from-yellow-400 via-yellow-300 to-yellow-500 hover:from-yellow-500 hover:via-yellow-400 hover:to-yellow-300 text-black font-bold py-3 px-8 rounded-lg text-lg relative overflow-hidden transition-all duration-300"
              >
                <span className="relative z-10">I’m Ready to Take Action →</span>
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent -skew-x-12 animate-shimmer"></div>
              </button>
            </motion.div>
          </div>
        </section>

        <section className="py-12 sm:py-20 bg-gradient-to-b from-black to-amber-900 relative">
          <div className="relative z-10 max-w-5xl mx-auto px-4 text-center">
            <motion.h2
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              className="text-3xl sm:text-5xl font-black text-white mb-10"
            >
              👥 <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-amber-500">Perfect for</span> Every Business Professional
            </motion.h2>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-6">
              {[
                { title: "Business Owners", icon: IconBriefcase }, { title: "Professionals", icon: IconUsers },
                { title: "Coaches", icon: IconAward }, { title: "Trainers", icon: IconBookOpen },
                { title: "Consultants", icon: IconMessageCircle }, { title: "Freelancers", icon: IconZap },
                { title: "Local Stores", icon: IconShoppingCart }, { title: "Agency Owners", icon: IconBarChart2 }
              ].map((item, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, scale: 0.8 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ delay: index * 0.1 }}
                  className="bg-gray-800/50 border border-yellow-400/20 rounded-xl p-6"
                >
                  <item.icon className="w-8 h-8 text-yellow-400 mx-auto mb-3" />
                  <h3 className="font-bold text-white">{item.title}</h3>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        <section id="testimonials" className="py-12 sm:py-20 bg-gradient-to-b from-amber-900 to-black relative">
          <div className="absolute inset-0 bg-gradient-to-r from-yellow-500/3 to-amber-500/3"></div>
          <div className="relative z-10 max-w-7xl mx-auto px-4">
            <motion.div
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              className="text-center mb-12"
            >
              <h2 className="text-3xl sm:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-amber-500 mb-6">
                🌟 Success Stories from Readers Like You
              </h2>
            </motion.div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {testimonials.map((testimonial, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: index * 0.1 }}
                  className="bg-gradient-to-b from-gray-800/50 to-amber-900/50 backdrop-blur-lg border border-yellow-400/20 rounded-2xl p-6"
                >
                  <div className="flex items-center gap-1 mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <IconStar key={i} className="w-4 h-4 text-yellow-400 fill-current" />
                    ))}
                  </div>
                  <blockquote className="text-gray-300 mb-4 italic text-base leading-relaxed">
                    "{testimonial.quote}"
                  </blockquote>
                  <div className="border-t border-gray-700 pt-4">
                    <div className="font-bold text-white text-base">{testimonial.name}</div>
                    <div className="text-yellow-400 text-sm font-medium">{testimonial.role}</div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 sm:py-20 bg-gradient-to-b from-black to-amber-900 relative">
          <div className="relative z-10 max-w-5xl mx-auto px-4 text-center">
            <motion.h2
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              className="text-3xl sm:text-5xl font-black text-white mb-10"
            >
              ⚙️ Start in Just <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-amber-500">3 Simple Steps</span>
            </motion.h2>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="flex flex-col items-center">
                <div className="w-16 h-16 rounded-full bg-yellow-500 text-black font-black text-3xl flex items-center justify-center mb-4">1</div>
                <h3 className="text-xl font-bold text-white mb-2">Purchase the eBook</h3>
                <p className="text-gray-400">Click any button and complete the secure payment for just ₹97.</p>
              </div>
              <div className="flex flex-col items-center">
                <div className="w-16 h-16 rounded-full bg-yellow-500 text-black font-black text-3xl flex items-center justify-center mb-4">2</div>
                <h3 className="text-xl font-bold text-white mb-2">Get Instant Access</h3>
                <p className="text-gray-400">Check your email for the instant download link to the eBook and all your bonuses.</p>
              </div>
              <div className="flex flex-col items-center">
                <div className="w-16 h-16 rounded-full bg-yellow-500 text-black font-black text-3xl flex items-center justify-center mb-4">3</div>
                <h3 className="text-xl font-bold text-white mb-2">Start Automating Sales</h3>
                <p className="text-gray-400">Follow the workshop, implement the strategies, and watch your sales grow! 🚀</p>
              </div>
            </div>
            <motion.div className="mt-12" initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}>
              <button
                onClick={openRegistrationModal}
                className="bg-gradient-to-r from-yellow-400 via-yellow-300 to-yellow-500 hover:from-yellow-500 hover:via-yellow-400 hover:to-yellow-300 text-black font-bold py-4 px-10 rounded-lg text-xl relative overflow-hidden transition-all duration-300"
              >
                <span className="relative z-10">Get Instant Access for ₹97 →</span>
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent -skew-x-12 animate-shimmer"></div>
              </button>
            </motion.div>
          </div>
        </section>

        <section className="py-12 sm:py-20 bg-gradient-to-br from-amber-900 via-black to-yellow-900 relative">
          <div className="relative z-10 max-w-4xl mx-auto px-4 text-center">
            <motion.div
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              className="bg-gray-900/60 backdrop-blur-md border-2 border-yellow-400/50 rounded-3xl p-6 sm:p-8"
            >
              <h2 className="text-3xl sm:text-5xl font-black text-white mb-4">💵 Grab the Entire Diwali Stack Before It’s Gone</h2>
              <div className="bg-red-500/20 border border-red-500 rounded-xl p-4 max-w-xs mx-auto mb-6">
                <div className="text-xl font-black text-white">{bonusTimeLeft.minutes.toString().padStart(2, '0')} : {bonusTimeLeft.seconds.toString().padStart(2, '0')}</div>
              </div>
              <div className="text-left max-w-md mx-auto space-y-2 mb-6">
                <p className="flex justify-between text-gray-300"><span>📚 24 Ways eBook</span> <span className="font-bold text-white">₹997</span></p>
                <p className="flex justify-between text-gray-300"><span>🎯 Diwali Workshop</span> <span className="font-bold text-white">₹4,999</span></p>
                <p className="flex justify-between text-gray-300"><span>⚡ Automation Templates</span> <span className="font-bold text-white">₹3,999</span></p>
                <p className="flex justify-between text-gray-300"><span>🛠️ Software Access</span> <span className="font-bold text-white">₹5,999</span></p>
                <p className="flex justify-between text-gray-300"><span>📱 WhatsApp Tutorial</span> <span className="font-bold text-white">₹6,999</span></p>
                <p className="flex justify-between text-gray-300"><span>🎯 Lead Gen Playbook</span> <span className="font-bold text-white">₹3,499</span></p>
                <div className="border-t border-gray-700 my-2"></div>
                <p className="flex justify-between text-lg font-bold text-yellow-400"><span>💰 Total Worth</span> <span>₹26,492</span></p>
              </div>
              <div className="bg-yellow-500/10 border border-yellow-500 rounded-xl p-4 mb-6">
                <div className="text-xl font-bold text-white mb-2">🎉 Your Price Today: <span className="line-through">₹26,492</span></div>
                <div className="text-4xl font-black text-green-400">₹97 <span className="text-lg">(One-Time Payment)</span></div>
              </div>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm text-green-300 mb-6">
                <li className="flex items-center justify-center sm:justify-start gap-2"><IconCheck /> Instant Access</li>
                <li className="flex items-center justify-center sm:justify-start gap-2"><IconCheck /> 5 Bonuses Included</li>
                <li className="flex items-center justify-center sm:justify-start gap-2"><IconCheck /> 7-Day Action Guarantee</li>
                <li className="flex items-center justify-center sm:justify-start gap-2"><IconCheck /> Secure Razorpay Payment</li>
              </ul>
              <button onClick={openRegistrationModal} className="w-full bg-gradient-to-r from-yellow-400 via-yellow-300 to-yellow-500 hover:from-yellow-500 hover:via-yellow-400 hover:to-yellow-300 text-black font-black py-5 px-12 rounded-xl text-xl relative overflow-hidden transition-all duration-300">
                <span className="relative z-10">💥 Proceed to Payment – ₹97</span>
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent -skew-x-12 animate-shimmer"></div>
              </button>
            </motion.div>
          </div>
        </section>

        <section id="faq" className="py-12 sm:py-20 bg-gradient-to-b from-black to-amber-900 relative">
          <div className="absolute inset-0 bg-gradient-to-r from-yellow-500/3 to-amber-500/3"></div>
          <div className="relative z-10 max-w-4xl mx-auto px-4">
            <motion.div
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              className="text-center mb-12"
            >
              <h2 className="text-3xl sm:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-amber-500 mb-4">
                ❓ Frequently Asked Questions
              </h2>
            </motion.div>

            <div className="space-y-4">
              {faqs.map((faq, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: index * 0.1 }}
                  className="bg-gradient-to-r from-gray-800/50 to-amber-900/50 backdrop-blur-lg border border-yellow-400/20 rounded-xl"
                >
                  <button
                    onClick={() => setOpenFaq(openFaq === index ? null : index)}
                    className="w-full px-4 sm:px-6 py-4 text-left flex justify-between items-center"
                  >
                    <span className="font-bold text-white text-base pr-4">{faq.question}</span>
                    <IconChevronDown className={`w-5 h-5 text-yellow-400 transition-transform ${openFaq === index ? 'rotate-180' : ''}`} />
                  </button>
                  <AnimatePresence>
                    {openFaq === index && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }}
                        className="overflow-hidden"
                      >
                        <div className="px-4 sm:px-6 pb-4 text-gray-300 border-t border-yellow-400/20 pt-4">{faq.answer}</div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 sm:py-20 bg-gradient-to-b from-amber-900 to-black relative">
          <div className="relative z-10 max-w-4xl mx-auto px-4 text-center">
            <motion.div
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              className="space-y-6"
            >
              <h2 className="text-3xl sm:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-amber-500">
                🕛 Last Chance to Unlock 24 Ways for ₹97
              </h2>
              <p className="text-red-400 font-bold">Note: Timer resets only once – Bonuses vanish when it ends.</p>
              <div className="bg-red-500/20 border-2 border-red-500 rounded-2xl p-4 max-w-xs mx-auto">
                <div className="text-3xl font-black text-white">{bonusTimeLeft.minutes.toString().padStart(2, '0')} : {bonusTimeLeft.seconds.toString().padStart(2, '0')}</div>
              </div>
              <motion.button
                whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}
                onClick={openRegistrationModal}
                className="bg-gradient-to-r from-yellow-400 via-yellow-300 to-yellow-500 hover:from-yellow-500 hover:via-yellow-400 hover:to-yellow-300 text-black font-black py-6 px-12 rounded-2xl text-xl shadow-2xl border-2 border-yellow-300 w-full max-w-2xl mx-auto relative overflow-hidden"
              >
                <span className="relative z-10">💥 Get the eBook Now Before Offer Ends →</span>
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -skew-x-12 animate-shimmer"></div>
              </motion.button>
              <p className="text-gray-300 italic">“Don’t let this opportunity slip away. Your future self will thank you.”</p>
            </motion.div>
          </div>
        </section>

        <footer className="bg-black border-t border-yellow-400/20 py-8">
          <div className="max-w-7xl mx-auto px-4">
            <div className="grid md:grid-cols-3 gap-8 text-center md:text-left">
              <div>
                <h3 className="text-2xl font-black text-white mb-2">🪔 YinGuru</h3>
                <p className="text-gray-400 text-sm">Empowering businesses to achieve exponential growth through proven strategies and automation.</p>
              </div>
              <div>
                <h4 className="text-lg font-bold text-white mb-4">Contact Info</h4>
                <div className="space-y-2 text-gray-400 text-sm">
                  {/* --- FIX STARTS HERE --- */}
                  <p className="flex items-center justify-center md:justify-start gap-2">
                    <IconMail className="w-5 h-5 text-yellow-400 flex-shrink-0"/> support@yinguru.com
                  </p>
                  <p className="flex items-center justify-center md:justify-start gap-2">
                    <IconPhone className="w-5 h-5 text-yellow-400 flex-shrink-0"/> +91-9884899080
                  </p>
                  {/* --- FIX ENDS HERE --- */}
                </div>
              </div>
              <div>
                <h4 className="text-lg font-bold text-white mb-4">Quick Links</h4>
                <div className="space-y-2 text-gray-400 text-sm">
                  <div><a href="https://funnelsdone.com/terms" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-400">Terms & Conditions</a></div>
                  <div><a href="https://funnelsdone.com/privacy" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-400">Privacy Policy</a></div>
                  <div><a href="https://funnelsdone.com/refund-policy" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-400">Refund Policy</a></div>
                </div>
              </div>
            </div>
            <div className="border-t border-gray-800 mt-8 pt-6">
              <div className="text-xs text-gray-500 bg-gray-900/50 rounded-xl p-4 border border-gray-800 mb-4">
                <strong className="text-yellow-400">Disclaimer:</strong> This site is not a part of the Facebook™ website or Facebook™ Inc. Additionally, This site is NOT endorsed by Facebook™ in any way. FACEBOOK™ is a trademark of FACEBOOK™, Inc. Results vary based on implementation and effort. We provide AI-driven business strategies designed for professionals.
              </div>
              <div className="text-center text-gray-400 text-sm">
                &copy; 2025 Funnelsdone LLC. All rights reserved.
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default App;